import _extends from "@babel/runtime/helpers/extends";
import { Card, Link, Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import React from 'react';
import { backgroundImageStyle } from "../../utils/getBackgroundStyle";
import { Picture } from "../Picture";
import { useIsDesktopDimension } from "../../hooks/useGetDimensionGroup";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
var InfoBanner = function InfoBanner(_ref) {
  var title = _ref.title,
    backgroundPosition = _ref.backgroundPosition,
    backgroundSize = _ref.backgroundSize,
    fullBackgroundOnDeviceSize = _ref.fullBackgroundOnDeviceSize,
    text = _ref.text,
    button = _ref.button,
    backgroundColor = _ref.backgroundColor,
    img = _ref.img,
    textIsRight = _ref.textIsRight,
    children = _ref.children,
    _ref$titleColor = _ref.titleColor,
    titleColor = _ref$titleColor === void 0 ? 'grey95' : _ref$titleColor,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? 'grey95' : _ref$textColor;
  var isDesktop = useIsDesktopDimension();
  var isShowBg = fullBackgroundOnDeviceSize || isDesktop;
  var wrapperStyles = backgroundImageStyle(isShowBg, img === null || img === void 0 ? void 0 : img.src, backgroundPosition, backgroundSize, backgroundColor);
  return /*#__PURE__*/React.createElement(Card, {
    className: cn('card'),
    "data-t-id": "components-InfoBanner"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('content', {
      'align-text-right': textIsRight
    }),
    style: wrapperStyles,
    "data-t-id": "components-InfoBanner"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('details')
  }, title && /*#__PURE__*/React.createElement(Text, {
    color: titleColor,
    size: "size1-m",
    tagType: "h2"
  }, title), text && /*#__PURE__*/React.createElement("div", {
    className: cn('details__text')
  }, /*#__PURE__*/React.createElement(Text, {
    color: textColor,
    size: "size4-r"
  }, text)), children && /*#__PURE__*/React.createElement("div", {
    className: cn('details__children')
  }, children), (button === null || button === void 0 ? void 0 : button.link) && (button === null || button === void 0 ? void 0 : button.text) && /*#__PURE__*/React.createElement("div", {
    className: cn('details__button')
  }, /*#__PURE__*/React.createElement(Link, {
    buttonSize: "l",
    buttonVariant: button.variant || 'secondary',
    href: button.link,
    onClick: button.onClick,
    size: "size5-m",
    variant: "button"
  }, button.text))), /*#__PURE__*/React.createElement("div", {
    className: cn('details__img')
  }, (img === null || img === void 0 ? void 0 : img.src) && /*#__PURE__*/React.createElement(Picture, _extends({
    className: cn('img', {
      'img--hidden': fullBackgroundOnDeviceSize
    })
  }, img)))));
};
export { InfoBanner };